<div class="chat-list-row" id="question{{ data?.qid }}">
  <div class="question">
    {{ data.question }}
  </div>
  <div class="answer">
    <div class="answer-header">
      <span class="menu-list">
        <ul>
          <li
            (keydown.enter)="refreshAnswer()"
            (keydown.space)="refreshAnswer()"
            (click)="refreshAnswer()"
            (keydown.enter)="refreshAnswer()"
            [title]="'Refresh Answer'"
          >
            <i
              [class]="isRefreshing ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'"
            ></i>
          </li>
          @if (section != "contract") {
            <li
              (keydown.enter)="editAnswer()"
              (keydown.space)="editAnswer()"
              (click)="editAnswer()"
              (keydown.enter)="editAnswer()"
              [title]="'Edit your answer'"
            >
              <i class="pi pi-pencil"></i>
            </li>
          }
          <li
            [title]="data?.is_pinned ? 'Unpin Record' : 'Pin Record'"
            (click)="pinRecord()"
            (keydown.enter)="pinRecord()"
            (keydown.space)="pinRecord()"
            [class.active-pinned]="data?.is_pinned"
          >
            <i class="pi pi-thumbtack"></i>
          </li>
          <li [title]="'Read Aloud'">
            <app-toggle-icon
              [icons]="volumeicons"
              [defaultState]="'off'"
              (iconState)="speakText($event, data)"
            ></app-toggle-icon>
          </li>
          <li
            [title]="'Generate Audio File'"
            (keydown.enter)="actionItems('audio')"
            (keydown.space)="actionItems('audio')"
            (click)="actionItems('audio')"
            (keydown.enter)="actionItems('audio')"
          >
            <i class="bi bi-file-earmark-music"></i>
          </li>
          <li
            [title]="'Generate Document'"
            (keydown.enter)="fileGenerate()"
            (keydown.space)="fileGenerate()"
            (click)="fileGenerate()"
          >
            <i class="pi pi-file-o"></i>
          </li>
        </ul>
      </span>
    </div>

    <!-- View mode -->
    @if (!isEditing) {
      <div
        class="answer-content"
        [innerHTML]="$safeNavigationMigration(data?.answer)"
      ></div>
    }

    <!-- Edit mode -->
    @if (isEditing) {
      <div class="answer-edit">
        <textarea class="textarea" rows="6" [(ngModel)]="editedAnswer">
        </textarea>
        <div class="edit-form-btns">
          <button
            type="button"
            class="button cancel"
            (click)="cancelEdit()"
            (keydown.enter)="cancelEdit()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="button save"
            (click)="saveAnswer()"
            (keydown.enter)="saveAnswer()"
            [disabled]="isSaving"
          >
            @if (isSaving) {
              <i class="pi pi-spin pi-spinner"></i>
            }
            Save
          </button>
        </div>
      </div>
    }
    <div class="source-label py-1">
      @if (data.source_paragraphs && data.source_paragraphs.length > 0) {
        <div class="answer-tags">
          <span
            (click)="toggleTextView()"
            (keydown.enter)="toggleTextView()"
            class="tag is-info is-light"
            style="cursor: pointer"
          >
            {{ showTextView ? "Hide" : "View" }}
          </span>
          <br />
          @if (showTextView) {
            <span
              [innerHTML]="fileSources_para_text(data.source_paragraphs)"
              style="text-align: justify"
            ></span>
          }
        </div>
      }
    </div>

    <div class="comment-form">
      <button
        type="button"
        class="button is-rounded"
        [ngClass]="{ 'selected-btn': accurate === 'No' }"
        (click)="isaccurate('No')"
        (keydown.enter)="isaccurate('No')"
      >
        <i class="pi pi-thumbs-down"></i></button
      >&nbsp;&nbsp;
      <button
        type="button"
        class="button is-rounded"
        (click)="isaccurate('Yes')"
        (keydown.enter)="isaccurate('Yes')"
        style="margin-right: 10px"
        [ngClass]="{ 'selected-btn': accurate === 'Yes' }"
      >
        <i class="pi pi-thumbs-up"></i>
      </button>
      @if (showfeedbackForm) {
        <div class="comments-field">
          <form [formGroup]="commentForm">
            <div class="field">
              <textarea
                TrimText
                class="textarea"
                rows="3"
                cols="35"
                formControlName="comment"
                (keyup)="onKeypressEvent($event)"
                placeholder="Enter your comments"
              ></textarea>
            </div>
            @if (
              submitted && commentForm.controls["comment"].hasError("required")
            ) {
              <span class="text-danger">Enter your comment. </span>
            }
            @if (
              submitted &&
              commentForm.controls["comment"].value != "" &&
              commentForm.controls["comment"].hasError("pattern")
            ) {
              <span class="text-danger">Enter comment. </span>
            }
            <div class="form-btns">
              <button
                type="button"
                class="button cancel"
                (click)="cancel()"
                (keydown.enter)="cancel()"
              >
                Cancel
              </button>
              <button
                class="button save"
                (click)="postComment()"
                (keydown.enter)="postComment()"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      }
    </div>
  </div>
  <div
    class="date-label d-flex justify-content-end align-items-center px-1 gap-2"
  >
    @if (data?.category_name) {
      <span class="category-badge">
        {{ data?.category_name }}
      </span>
    }
    <span class="meta-info">
      {{ data?.updated_by_name || data?.created_by_name }} &nbsp;·&nbsp;
      {{
        $safeNavigationMigration(data?.updated_at || data?.created_at)
      }}
    </span>
  </div>
</div>
